
const internal = Symbol('SurvayService')

class Dom {

  static instance = []

  constructor (token) {
  	if (token !== internal) {
      throw new Error('Please use the Service.getInstance() static method instead')
    }
    this.globalState = {}
  }

  static getInstance () {
    if (Dom.instance[this.id]) {
      return Dom.instance[this.id]
    }
    Dom.instance[this.id] = new this(internal)
    return Dom.instance[this.id]
  }

  waitForElm (selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector))
      }
      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector))
          observer.disconnect()
        }
      })
      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    })
  }

  Ready () {
    window.addEventListener('load', this.manypulate)
    window.addEventListener('scroll', this.manypulate)
    window.addEventListener('resize', this.manypulate)
  }

  manypulate () {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    const category = document.querySelector('.category-seaction')
    const tableThs = document.querySelectorAll('.responstable th')
    const tableSucess = document.querySelectorAll('.table-success td')

    const fixed = document.querySelector('#fixed')
    const excel = document.querySelector('#excel')
    
    const hightChart = document.querySelector('#hight-chart')
    const chartTitle = document.querySelector('.chart-title')
    const wordMap = document.querySelector('#world-map')
    const BarChart = document.querySelector('#bar-chart')
    const staticStyked = document.querySelector('.staic-styked')
    const source = document.querySelector('.source')
    const notification = document.querySelector('.notification')
    const activePage = BarChart ?? hightChart ?? wordMap ?? staticStyked
    
    const needCategory = window.innerWidth >= 1200 && category ? category.offsetHeight : 17
    const needFixedHeight = window.innerWidth >= 1200 && fixed ? fixed.offsetHeight : 7
    const needExcelHeight = window.innerWidth >= 1200 && excel ? excel.offsetHeight : 0
    const needChartTitleHeight = window.innerWidth >= 1200 && chartTitle ? chartTitle.offsetHeight + 17 : 0

    

    if (window.innerWidth >= 1200) {
      category && (category.style.top = document.getElementById('main-menu').clientHeight + 'px')
      if (fixed) fixed.style.top = ((document.getElementById('main-menu').clientHeight + needCategory) - 2) + 'px'
      if (excel) excel.style.top = ((document.getElementById('main-menu').clientHeight + needFixedHeight + needCategory) - 2) + 'px'
    } else {
      category.removeAttribute('style')
      fixed.removeAttribute('style')
      excel.removeAttribute('style')
    }

    if (currentScrollPosition > 0) {
      const pixel = (document.getElementById('main-menu').clientHeight + needCategory)
      activePage && (activePage.style.top = pixel + needChartTitleHeight + 'px')
      activePage && source && (source.style.top = (pixel + needChartTitleHeight + activePage.offsetHeight) + 'px')
      activePage && notification && (notification.style.top = (pixel + needChartTitleHeight + activePage.offsetHeight + source.offsetHeight) + 'px');

      // category.style.boxShadow = '0 5px 5px rgb(0 0 0 / 5%)';
      [...tableThs].map((elm, index) => {
        elm.style.top = ((document.getElementById('main-menu').clientHeight + needCategory + needExcelHeight) - 10) + needFixedHeight + 'px'
        // elm.style.boxShadow = '0 5px 5px rgb(0 0 0 / 5%)'
      });

      [...tableSucess].map((elm, index) => {
        elm.style.top = ((document.getElementById('main-menu').clientHeight + needCategory + needExcelHeight) - 10) + needFixedHeight + tableThs[0].clientHeight + 'px'
        // elm.style.boxShadow = '0 5px 5px rgb(0 0 0 / 5%)'
      })



    } else {
      // category.removeAttribute('style');
      [...tableThs].map((elm, index) => {
        elm.removeAttribute('style')
      })
      activePage && activePage.removeAttribute('style')
      source && source.removeAttribute('style')
      notification && notification.removeAttribute('style')
    }
  }

}

Dom.id = 'Dom'

export default Dom


